<div [class.fade]="true" [class.in]="true" [class.show]="true" role="dialog"
	[ngStyle]="{'display': 'none', 'z-index':'9999'}" id="icon-upload-confirm-dialog" *ngIf="loaded">
	
	<div class="modal-header" id="iconUploadConfirmDialogHeader">
		<button type="button" class="close" data-dismiss="modal">x</button>
		<h4 class="modal-title">ICON MAY BE RESIZED</h4>
	</div>
	<div class="modal-body">
		<p>The server's max icon size (height or width) is {{maxIconRes}} pixels. If this icon is larger, it will be
			resized.</p>
		<p></p>
		<p>Would you like to proceed?</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-default" data-dismiss="modal" (click)="decline()">NO</button>
		<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="accept()">YES</button>
	</div>
</div>